
import { post, getJson,get } from '@/api/http';

/*获取当前直播间信息 */
export const getLiveInfo = (liveId) => get(`${config.cppm}monitor/v2/webcast/`,liveId)
/** 设置当前直播间状态是否开启直播 */
export const setLiveState = (data,webcastId,token) => post(`${config.cppm}monitor/v2/webcast/${webcastId}/state`,data,{token})
/**
 *
 * 获取连麦审核列表
 * @export
 * @param {*} data
 * @returns
 */
export const getApplyUserRequestList = (token)=> getJson(`${config.cppm}monitor/v1/voip/users`,null,{token});


/**
 *
 * 连麦列表搜索接口
 * @export
 * @param {*} data
 * @returns
 */


export const searchVoipUserList =(params,token)=>getJson(`${config.cppm}monitor/v1/voip/user/list`,params,{token})
/** 设置连麦请求状态（同意、拒绝、挂断） */

export const  setVoiconpReply = (data,token) => post(`${config.cppm}monitor/v1/voip/reply`,data,{token})
/* 拒绝全部连麦申请 */


export const refuseUserVoip = (token)=>  getJson(`${config.cppm}monitor/v1/voip/users/refuse`,{token},{token})

/** 更新连麦的信息，比如: 音视频状态 */
export const  updateVoipUserInfo = (params,token) => post(`${config.cppm}monitor/v2/voip/change/status`, params, {token})

/**
 *
 * 获取在线人数
 * @export
 * @param {*} data
 * @returns
 */
export function getTotalCount(params) {
  return getJson({
    url: `/monitor/v1/webcast/total`,
    method: 'GET',
    params
  });
}

/** 设置录制转态接口 */ 
export const setRecordStatus = (data,token) => post(`${config.cppm}monitor/v2/webcast/${data.webcastId}/record/${data.status}`,null,{token})
/**
 *
 * 获取当前合同状态
 * @export
 * @param {*} data
 * @returns
 */
// export function getContractState(params) {
//   return getJson({
//     url: `/monitor/v1/contract/${params.webcastId}`,
//     method: 'GET',
//     params
//   });
// }
// /v1/voip/change/join/{webcastId}/{status}

export const changeLianMaiStatus = (params,token) =>post(`${config.cppm}monitor/v2/voip/change/join`,params,{token})
/**
 *
 *助手回复消息
 * @export
 * @param {*} data
 * @returns
 */


export const sendMsgToViewer = (Info, params,token)=>post(`${config.cppm}monitor/v1/signaling/${Info.webcastId}/to/user/${Info.userId}`,params,{token})


//设置嘉宾对观众的可见状态

// 获取嘉宾对观众的可见状态

export const setGuestSeeAuth = (stat,token)=>post(`${config.cppm}monitor/v2/webcast/guest_see_auth/${stat}`,null,{token})

// 修改昵称
export const setNickname = (nickName,uid,token)=>getJson(`${config.cppm}monitor/v2/webcast/user/update_name/${nickName}`, {guestUserId:uid},{token})

// 增加了文档为主,视频为主的切换接
export const switchMain = (status,token)=>getJson(`${config.cppm}monitor/v2/webcast/doc_or_video/audience/${status}`, null,{token})

// 插播全员静音
export const mediaRoomMute = (status,token)=>getJson(`${config.cppm}monitor/v2/webcast/live_ondemand_voice/enable/${status}`, null,{token})

//不合规列表
export const tripartiteLsit = (params,token)=>post(`${config.cppm}monitor/v2/tripartite/picture/list`, params,{token})